import $ from 'jquery'

const breakpoint = 897

export const initBreakpointChangeEvent = () => {
  const mq = window.matchMedia(`screen and (min-width: ${breakpoint}px)`)
  const handlerChange = function () {
    $(window).trigger('breakpointChange')
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', handlerChange)
  } else if (mq.addListener) {
    mq.addListener(handlerChange) // For IE11
  }
}

export const isPC = () => {
  const mq = window.matchMedia(`screen and (min-width: ${breakpoint}px)`)
  return mq.matches
}

export const isSP = () => {
  const mq = window.matchMedia(`screen and (max-width: ${breakpoint - 1}px)`)
  return mq.matches
}

export const isTouchDevice = () => !!('ontouchstart' in window || navigator.maxTouchPoints)

export const setViewport = () => {
  const ua = navigator.userAgent.toLowerCase()
  const viewSize = 1280

  if (
    ua.indexOf('ipad') > 0
    || (ua.indexOf('android') > 0 && ua.indexOf('mobile') < 0)
    || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
  ) {
    $('meta[name="viewport"]').attr('content', `width=${viewSize}, user-scalable=yes, initial-scale=0.8, maximum-scale=0.8`)
  }
}
